export default __webpack_public_path__ + "static/media/pro-elevate-pyl-banner-2.1153b9f1.jpg";